/**
 * 当前环境是否为开发模式
 */
export const isDevMode = process.env.NODE_ENV === 'development'

/**
 * 当前环境是否为生产模式
 */
export const isProdMode = process.env.NODE_ENV === 'production'

export const SHOP_ID = 1

export const SUPPORT_OBSERVER = 'IntersectionObserver' in window
export const TABS_MAP = [
  {
    tab: 'all',
    img: 0,
  },
  {
    tab: 'has-img',
    img: 1,
  },
]

export const NO_START = 0
export const PLAYING = 1
export const PAUSED = 2
export const ENDED = 3
export const VIDEO_STATUS = {
  NO_START: NO_START,
  PLAYING: PLAYING,
  PAUSED: PAUSED,
  ENDED: ENDED,
}

//1 :已上线 0 :已下线 -1 :已删除 100:预售
export const PRODUCT_STATUS_MAP = {
  /**
   * 100预售
   */
  PRE_SELL: 100,
  SELLING: 1,
  REMOVED: -1,
  OFF_LINE: 0,
}
export const SESSION_GROUP_KEY = 'MALL-GROUP'

export const STATIONERY = 'stationery'
export const BOOKS = 'books'
export const CLASSIFY_TAGS_BAN_MAP = {
  [STATIONERY]: [
    {
      img: 'https://7n.bczcdn.com/r/anqeru49gml4rfe7b54xw4k6qka5agd2.png',
      link: '',
    },
    {
      img: 'https://7n.bczcdn.com/r/6mxunqjj8prwl7d6g5utzlezruhfwbp6.png',
      link: 'https://bcz-mall.baicizhan.com/new-mall/tags?tagId=163',
    },
    {
      img: 'https://7n.bczcdn.com/r/567ls5lzu7ydz244m52nvebsey8l7gr8.png',
      link: 'https://bcz-mall.baicizhan.com/new-mall/tags?tagId=164',
    },
  ],
  [BOOKS]: [
    {
      img: 'https://7n.bczcdn.com/r/pmfgkqukv96bm64mlldgmmdxwzkxfrrm.png',
      link: '',
    },
    {
      img: 'https://7n.bczcdn.com/r/myzy3g5vwzdtv58828j3ph5he5kpmptq.png',
      link: 'https://bcz-mall.baicizhan.com/new-mall/detail/2014794',
    },
    {
      img: 'https://7n.bczcdn.com/r/2eflsjnpaqbqa7jx4hlxfuypfvd23nqn.png',
      link: 'https://bcz-mall.baicizhan.com/new-mall/detail/2014799',
    },
  ],
}
export const CLASSIFY_TAGS_MAP = {
  [STATIONERY]: [
    { tagId: '234', name: '7折' },
    { tagId: '233', name: '8折' },
    { tagId: '232', name: '9折' },
    { tagId: '231', name: '限时低价' },
  ],
  [BOOKS]: [
    { tagId: '227', name: '大学' },
    { tagId: '228', name: '高中' },
    { tagId: '229', name: '初中' },
    { tagId: '230', name: '吉时限定' },
  ],
}

//首页 用户的活动状态
export const USER_STATUS = {
  INELIGIBLE: -10, //不符合活动条件
  NO_JOIN: -1, // 符合条件-未参加
  NO_AWARD: 0, //已领取-未使用
  AWARDED: 1, //已领取-交易中
  USED: 2, //已使用
  EXPIRED: 10, //已失效
}
export const PROGRAM_ID = 'gh_d016533c62a6'

//进入小卖部小程序
export const DOUBLE11_PUBLIC_URL =
  'http://mp.weixin.qq.com/s?__biz=MzIzMjY0NDM2OQ==&mid=100000854&idx=1&sn=bc59b79b8bb978dc7764a031239fad85&chksm=68908e285fe7073e4645bf764b6c3b5802d23e27a2e0a5c34c39287881ebf9e6505ab2eabf73#rd'

//进入免单小程序
export const DOUBLE11_PUBLIC_URL2 =
  'http://mp.weixin.qq.com/s?__biz=MzIzMjY0NDM2OQ==&mid=100000858&idx=1&sn=ae85fe746fc3a2b44d7dba520271b463&chksm=68908e245fe70732c46604eff04a1bac9194ceee920abe4b9eb5835c06dee170c2e59c64814b#rd'
//进入锦鲤小程序
export const DOUBLE11_PUBLIC_URL3 =
  'http://mp.weixin.qq.com/s?__biz=MzIzMjY0NDM2OQ==&mid=100000856&idx=1&sn=f0a67ffb2203f63eb7e3a1c92d42a756&chksm=68908e265fe707300dfd2e25c8b1ed0be110997b067ce63d5fbb677c52b779a201e75d9e1d4c#rd'

//双十一活动
export const USER_TYPE_NEW = 1
export const USER_TYPE_OLD = 2
export const WEB_BASE_URL = `${location.protocol}//${location.host}`

//分组
export const GROUP_A = 'A'
export const GROUP_B = 'B'
// export const SERVER_LINK = 'https://mall.baicizhan.com/1614072154579/m/call_center/index'
export const SERVER_LINK = `https://assistant.baicizhan.com/pages/feedback/index.html?clickFrom=BaicizhanMall&title=${encodeURIComponent(
  '商城客服',
)}`
//https://assistant.baicizhan.com/pages/feedback/index.html?clickFrom=BaicizhanMall&title=商城客服

/**
 * 统一配置结果页
 */
export const HOME_LINK = `${WEB_BASE_URL}/new-mall`
export const CART_LINK = `${HOME_LINK}/cart`
export const PAY_RESULT = `${HOME_LINK}/pay-result`
export const ORDER_DETAIL = `${HOME_LINK}/order-detail`
export const ORDER_LIST = `${WEB_BASE_URL}/new-mall/orders/#1`
export const EXPRESS_LINK = `${WEB_BASE_URL}/new-mall/express`
export const EVALUATE_LINK = `${WEB_BASE_URL}/new-mall/evaluate`
export const WISH_BASE_LINK = `${WEB_BASE_URL}/new-mall/wish`

export const AFTER_SALES = 'https://mall.baicizhan.com/m/order/after_sales'
export const ME_LINK = `${HOME_LINK}/mine`
export const PAY_RESULT11 = 'https://bcz-mall.baicizhan.com/new-mall/pay-result11'
export const PAY_RESULT_SALE = 'https://bcz-mall.baicizhan.com/new-mall/pay-result-sale'
const apiPath = '/api/mall/proxy'
export const apiBaseUrl = `https://learn.baicizhan.com${apiPath}`
// process.env.NODE_ENV === 'production' ? `https://learn.baicizhan.com${apiPath}` : apiPath

export const cartApiPath = `${apiBaseUrl}/cart`

export const AUTO_PAY_TEST = 'http://test.mall.baicizhan.com/m/v2/auto_pay'
export const AUTO_PAY_PRO = 'https://mall.baicizhan.com/m/v2/auto_pay'

export const globalRouters = []

export const ADDRESS_DEFAULT = 2
export const ADDRESS_SELECTED = 666

//订单页需要特殊处理的 省份id集合
// 710000 台湾
// 810000 香港
// 820000 澳门
export const SPECIAL_PROVINCE_IDS = [710000, 810000, 820000]

//需要特殊处理的商品
export const SPECIAL_PRODUCT_IDS = [49570, 49572, 49573, 49506, 49507, 49508]

//商品活动类型
export const ACTIVITY_TYPES = {
  /**
   * 新人送赠品
   */
  NEW_GIFG: 1,
  /**
   * 满赠 不是满减
   */
  MONEY_OFF: 2,
  /**
   * 换购
   */
  REDEMPTION: 3,
  /**
   * 优惠券
   */
  COUPON: 4,
  /**
   * 默认包邮策略
   */
  POSTAGE_OFF: 5,
  /**
   * 团购
   */
  GROUP_PURCHASE: 6,
  /**
   * 限时促销
   */
  PROMOTION: 7,
  /**
   * 买赠
   */
  GIFT: 8,
  /**
   * 多件多折 9
   */
  DISCOUNT: 9,
}
export const ACTIVITY_TYPES_INFO = {
  [ACTIVITY_TYPES.GIFT]: '赠品',
  [ACTIVITY_TYPES.REDEMPTION]: '换购',
  [ACTIVITY_TYPES.DISCOUNT]: '多买优惠',
}

export const PRODUCT_ITEM_TYPE = {
  BROWSE: 'browse',
  ADD_CART: 'addCart',
}

export const PAGE_ACTIVITY_ID = '20220801'

//心愿单订单状态
// 1:可创建订单状态 2:订单
export const WISH_ORDER_STATUS = {
  1: '正常',
  2: '订单未⽀付',
  3: '订单已⽀付',
}
